import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';
import classNames from 'classnames';
import { v1 as uuid } from 'uuid';
import RadioButtonAccessible from 'components/RadioButtonAccessible';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import QuestionHeader from '../QuestionHeader';

const BooleanType = ({ question, onUpdateVariable, skipTopMargin }) => {
  const { value, options = [] } = question;
  const [uniqueIds, setUniqueIds] = useState([]);

  useEffect(() => {
    setUniqueIds(options.map(() => uuid()));
  }, [options]);

  const onChange = useCallback(
    (event) => {
      let newValue = event.target.value;
      if (newValue === 'true') {
        newValue = true;
      }
      if (newValue === 'false') {
        newValue = false;
      }
      onUpdateVariable(newValue);
    },
    [onUpdateVariable],
  );

  return (
    <React.Fragment>
      <QuestionHeader
        title={question.body}
        note={question.note}
        skipTopMargin={skipTopMargin}
      />
      <div>
        <div className="position-relative">
          <RadioButtonAccessible.Group
            className={classNames('flex', 'justify-content-between')}
          >
            {options.map((option, index) => (
              <RadioButtonAccessible.Button
                value={option.value}
                key={String(option.value)}
                id={uniqueIds[index]}
                checked={value === option.value}
                onChange={onChange}
                className="margin-right-sm"
              >
                <div className="flex flex-items-center">
                  {option.body}
                  {option.info && (
                    <Tooltip
                      trigger="click"
                      overlayClassName="tooltip-light"
                      arrowPointAtCenter
                      getPopupContainer={(trigger) => trigger.parentNode}
                      title={option.info}
                    >
                      <span className="margin-left-xxs text-size-secondary line-height-clear color-grey-10">
                        <ExclamationCircleOutlined />
                      </span>
                    </Tooltip>
                  )}
                </div>
              </RadioButtonAccessible.Button>
            ))}
          </RadioButtonAccessible.Group>
        </div>
      </div>
    </React.Fragment>
  );
};

BooleanType.propTypes = {
  question: PropTypes.object,
  onUpdateVariable: PropTypes.func.isRequired,
  skipTopMargin: PropTypes.bool,
};

export default BooleanType;
